import { AuthState } from './_types';

const token = localStorage.getItem('token') || '';

export const initialState: AuthState = {
    authenticated: !!token,
    token,
};
